<template>
  <div class="page-identify-status">
    <el-dialog custom-class="status-dialog" :visible="true" width="600px" :show-close="false" :modal="false" top="0">
      <div class="content-inner">
        <img class="icon" v-if="authenticateStatus === -1" :src="require('@/assets/img/icon_x.png')" alt="" />
        <img
          v-else
          class="icon"
          src="https://static.kminghealth.com/attachment/20210930104955141_f904fd72d8d94b06aa0ef15271d18f80.png"
          alt=""
        />
        <span class="text1">{{ status[authenticateStatus] || '待买家认证' }}</span>
        <span class="text2">
          {{ statusText[authenticateStatus] || '请您前往智云问诊APP进行买家认证，感谢您的配合' }}
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/services';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  name: 'IdentifyStatus',
  data() {
    return {
      authenticateStatus: null,
      storeInfo: {},
      company: {},
      status: {
        '-1': '买家认证审核未通过',
        1: '买家认证审核中',
        2: '买家认证审核中',
        3: '买家认证审核中',
        9: '买家认证已通过'
      },
      statusText: {
        '-1': '您的认证未通过，请您前往智云问诊APP重新提交认证，感谢您的配合',
        1: '您的认证已提交，认证将在提交后3个工作日内完成审核，请耐心等待',
        2: '您的认证已提交，认证将在提交后3个工作日内完成审核，请耐心等待',
        3: '您的认证已提交，认证将在提交后3个工作日内完成审核，请耐心等待',
        9: '买家认证已通过'
      }
    };
  },
  computed: {
    ...mapState('USER', {
      userInfo: state => state.userInfo
    })
  },
  async created() {
    // 每次进入应用都去调用userInfo接口
    await this.getUserInfo();
    this.storeInfo = this.userInfo.enterpriseVO.stores[0];
    this.company = this.userInfo.enterpriseVO.company;
    const res = await api.personal.getPurchaseQualifies({
      shopId: this.storeInfo.id,
      merchantId: this.company.id
    });
    // this.authenticateStatus = res.authenticateStatus;
    // 配合技改 11.15
    this.authenticateStatus = res.customer.gspAuthStatus;

    if (!this.status[res.authenticateStatus]) {
      // 仅内容为【待买家认证】时记录
      Telescope.trackEvent({
        trackId: 'zyb2bpc-view-sy-dmjrztcB2B'
      })
    }
  },
  methods: {
    ...mapActions('USER', ['getUserInfo'])
  }
};
</script>

<style lang="scss" scoped>
.page-identify-status {
  height: 100%;
  background-image: url('https://static.kminghealth.com/attachment/20210929151439836_cf4ef3786b0241a1b97dbf3acd3fe4a0.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.status-dialog {
  margin-top: 0;
  vertical-align: middle;
  .content-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 168px;
  }
  .icon {
    width: 42px;
    height: 42px;
    margin-top: 17px;
  }
  .text1 {
    font-size: 16px;
    color: #262626;
    font-weight: 500;
    margin-top: 19px;
  }
  .text2 {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 12px;
    margin-bottom: 36px;
  }
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: ' ';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
